<template>
	<!--<div class="yh_index">-->
	<section class="yh_banner" :style="h_qq">
		<ul class="idx_nav_box">

			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/canal">
				<img src="../../static/img/index/index_4.png" alt="">
				<p class="special_name txt_center">
					大运河文化
				</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/beijing">
				<img src="../../static/img/index/idx_7.png" alt="">
				<p class="special_name txt_center">
					北京研究
				</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/tianjinHebei">
				<img src="../../static/img/index/idx_8.png" alt="">
				<p class="special_name txt_center">
					京津冀研究
				</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/subject">
				<img src="../../static/img/index/index_1.png" alt="">
				<p class="special_name txt_center">课题成果库</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/award">
				<img src="../../static/img/index/idx_6.png" alt="">
				<p class="special_name txt_center">
					评奖成果库
				</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/fund">
				<img src="../../static/img/index/index_2.png" alt="">
				<p class="special_name txt_center">
					基金成果库
				</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/yearbook">
				<img src="../../static/img/index/index_3.png" alt="">
				<p class="special_name txt_center">年鉴库</p>
				</router-link>
			</li>
			<li class="idx_nav_li special_item left">
				<router-link to="/harvest/periodical">
				<img src="../../static/img/index/idx_5.png" alt="">
				<p class="special_name txt_center">期刊库</p>
				</router-link>
			</li>
		</ul>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				sel_type: "1",
				key_word: '',
				hot_arr: [
					"京津冀",
					"北京研究",
					"大运河文化"
				],
				article_list: [],
				current_page: 1,
				idx_sel_arr: [{
						name: "标题",
						id: "1"
					},
					{
						name: "作者",
						id: "2"
					},
					{
						name: "单位",
						id: "3"
					},
					{
						name: "摘要",
						id: "4"
					},
					{
						name: "关键词",
						id: "5"
					}
				],
				h_qq: {
					height: "500px"
				}
			}
		},
		methods: {
			search_fn() {
				this.$router.push({
					path: "/Index_result",
					query: {
						key_word: this.key_word,
						sel_type: this.sel_type
					}
				})
			},
			current_page_fn(val) {
				this.current_page = val;
			},
			to_harvest(n) {
				this.$router.push({
					path: '/harvest',
					query: {
						data_state: n
					}
				})
			},

			to_hot_Fn() {

				this.$router.push({
					path: '/hot'
				})
			},
			get_h() {
				if((document.body) && (document.body.clientHeight))
					var h = document.documentElement.clientHeight - 140 + "px";
				console.log(h)
				if(h > 690) {
					this.h_qq.height = h + "px"
				} else {
					this.h_qq.height = 690 + "px"
				}
			}
		},
		mounted() {
			var me = this;
			me.get_h();
			window.onresize = function() {
				me.get_h();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import url("../assets/css/else");
	@import url("../assets/css/index");
	.yh_banner {
		width: 100%;
		background-size: cover;
		position: relative;
		padding: 100px;
	}
	
	.idx_nav_box {
		width: 940px;
		height: 490px;
		position: absolute;
		top: 50%;
		left: 50%;
		overflow: hidden;
		background: rgba(255, 255, 255, 1);
		margin-left: -470px;
		margin-top: -245px;
		padding: 25px 90px;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		padding: 50px 65px;
	}
	
	.idx_nav_li {
		width: 188px;
		height: 171px;
		background: rgba(238, 238, 238, 1);
		border-radius: 6px;
		margin: 7px;
	}
	.idx_nav_li {
		width: 188px;
		height: 171px;
		background: rgba(238, 238, 238, 1);
		border-radius: 6px;
		margin: 7px;
	}
		.idx_nav_li a{
		color: #000000;
		text-decoration: none;
	}
	.idx_nav_li:hover {
		background: rgba(249, 232, 201, 1);
	}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue